import { useQuery } from "@tanstack/react-query";
import type { StoreView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreQueryParams = {
  storeSlug: string;
};

export function useStoreQuery({ storeSlug }: UseStoreQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.store(storeSlug),
    queryFn: () => apiJsonClient<StoreView>(endpoints.seller.store, { cache: "no-store" }),
    enabled: storeSlug.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
